/**
 * @deprecated `ExpoRoot` mounts the navigation container automatically — there is no need
 * to render `BaseNavigationContainer` directly. Will be removed in a future SDK.
 */
export { BaseNavigationContainer } from './BaseNavigationContainer';
export { createNavigationContainerRef } from './createNavigationContainerRef';
export { createNavigatorFactory } from './createNavigatorFactory';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { CurrentRenderContext } from './CurrentRenderContext';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { findFocusedRoute } from './findFocusedRoute';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { getActionFromState } from './getActionFromState';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { getFocusedRouteNameFromRoute } from './getFocusedRouteNameFromRoute';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { getPathFromState } from './getPathFromState';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { getStateFromPath } from './getStateFromPath';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { NavigationContainerRefContext } from './NavigationContainerRefContext';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { NavigationContext } from './NavigationContext';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { NavigationHelpersContext } from './NavigationHelpersContext';
export { NavigationIndependentTree } from './NavigationIndependentTree';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { NavigationMetaContext } from './NavigationMetaContext';
export { NavigationProvider } from './NavigationProvider';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { NavigationRouteContext } from './NavigationProvider';
export { PreventRemoveContext } from './PreventRemoveContext';
export { PreventRemoveProvider } from './PreventRemoveProvider';
export {
  /**
   * @deprecated Expo Router builds components from the file-based route tree. Will be removed in a future SDK.
   */
  createComponentForStaticNavigation,
  /**
   * @deprecated Expo Router generates path config from the file-based route tree. Will be removed in a future SDK.
   */
  createPathConfigForStaticNavigation,
  /**
   * @deprecated Expo Router infers route types from the file-based route tree. Will be removed in a future SDK.
   */
  type StaticConfig,
  /**
   * @deprecated Will be removed in a future SDK.
   */
  type StaticConfigGroup,
  /**
   * @deprecated Will be removed in a future SDK.
   */
  type StaticConfigScreens,
  /**
   * @deprecated Will be removed in a future SDK.
   */
  type StaticNavigation,
  /**
   * @deprecated Use the typed routes API from `expo-router`. Will be removed in a future SDK.
   */
  type StaticParamList,
  /**
   * @deprecated Will be removed in a future SDK.
   */
  type StaticScreenProps,
} from './StaticNavigation';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { ThemeContext } from './theming/ThemeContext';
/**
 * @deprecated Import `ThemeProvider` from `expo-router` instead. Will be removed in a future SDK.
 */
export { ThemeProvider } from './theming/ThemeProvider';
/**
 * @deprecated Import `useTheme` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useTheme } from './theming/useTheme';
export * from './types';
/**
 * @deprecated Import `useFocusEffect` from `expo-router` instead — it is typed for the
 * Expo Router route tree. Will be removed in a future SDK.
 */
export { useFocusEffect } from './useFocusEffect';
/**
 * @deprecated Import `useIsFocused` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useIsFocused } from './useIsFocused';
/**
 * @deprecated Import `useNavigation` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useNavigation } from './useNavigation';
export { useNavigationBuilder } from './useNavigationBuilder';
/**
 * @deprecated Import `useNavigationContainerRef` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useNavigationContainerRef } from './useNavigationContainerRef';
export { useNavigationIndependentTree } from './useNavigationIndependentTree';
export { useNavigationState } from './useNavigationState';
export { usePreventRemove } from './usePreventRemove';
export { usePreventRemoveContext } from './usePreventRemoveContext';
/**
 * @deprecated Import `useRoute` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useRoute } from './useRoute';
export { useStateForPath } from './useStateForPath';
/**
 * @deprecated Will be removed in a future SDK.
 */
export { validatePathConfig } from './validatePathConfig';
export * from '../routers';
